import FORMAT_INPUT from 'constant/format-input-items'
import _ from 'lodash'

export default (article) => _.reduce(article, (result, value, key) => {
  const input = FORMAT_INPUT[key]

  if (input) {
    result[input.field] = input.value(value)
  }

  return result
}, { ...article })
